import type { RefObject } from 'react';
import { useEffect, useRef, useState } from 'react';

export function useOverflowCheck(): [RefObject<HTMLDivElement>, boolean] {
    const [isOverflow, change] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (ref.current) {
            const { offsetHeight, scrollHeight } = ref.current;
            const result = offsetHeight < scrollHeight;

            if (result !== isOverflow) {
                change(result);
            }
        }
    }, [isOverflow]);

    return [ref, isOverflow];
}
